import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthGuard } from './core';

import { HomeLayoutComponent } from './theme/home-layout/home-layout.component';
import { AuthLayoutComponent } from './theme/auth-layout/auth-layout.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { LoginComponent } from './pages/sessions/login/login.component';

const routes: Routes = [
  {
    path:'',
    component : HomeLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children:[
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent },
      {
        path: 'customers',
        loadChildren: () => import('./pages/customers/customers.module').then(m => m.CustomersModule)
      },
      {
        path: 'suppliers',
        loadChildren: () => import('./pages/suppliers/suppliers.module').then(m => m.SuppliersModule)
      },
      {
        path: 'pricelist',
        loadChildren: () => import('./pages/pricelist/pricelist.module').then(m => m.PriceListModule)
      },
      {
        path: 'history',
        loadChildren: () => import('./pages/history/history.module').then(m => m.HistoryModule)
      },
      {
        path: 'azioni',
        loadChildren: () => import('./pages/azioni/azioni.module').then(m => m.AzioniModule)
      },
      {
        path: 'user',
        loadChildren: () => import('./pages/user/user.module').then(m => m.UserModule)
      }
    ]
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children:[
      { path: 'login', component: LoginComponent },
      // { path: 'register', component: RegisterComponent },
      // { path: 'forgot-password', component: ForgotPassword}
    ]
  },
  { path: '**', redirectTo: 'dashboard', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    useHash : environment.useHash,
    relativeLinkResolution: 'legacy'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
